import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { CardModule } from 'primeng/card';
import { StorageService } from 'src/app/services/storage.service';
import { DeploymentCheckService } from 'src/app/services/deployment-check.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
  selector: 'app-maintenance',
  standalone: true,
  imports: [SharedModule, CardModule],
  templateUrl: './maintenance.component.html',
  styleUrl: './maintenance.component.scss'
})
export class MaintenanceComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  maintenanceMessage: string;
  currentYear: number = new Date().getUTCFullYear();
  constructor(private storageService: StorageService, private deploymentCheckService: DeploymentCheckService) { }

  ngOnInit() {
    this.maintenanceMessage = `<b>All services</b> will be <b>unavailable</b> in the application due to scheduled <b>maintenance</b> 
    on <b>Wednesday, 20 November 2024</b>, from <b>12:00 to 13:00. </b> <br/><br/>
    <b>Please try again later. Thankyou for your cooperation.<b>`;

    this.deploymentCheckService.currentMessage.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res) => {
      console.log('Maintenance message received in maintenance Component:', res);
      if (res?.downtime) {
        this.maintenanceMessage = res.message;
        if (res.redirectToLogout) {
          this.storageService.unAuthUserFound();
        }
      }
    });
  }

}
